<div class="h-full flex flex-col bg-neutral-3 rounded-2xl p-4">
  <div class="sticky top-0 z-10 bg-neutral-3 py-2 px-6 rounded-2xl">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-4xl font-bold flex items-center gap-2">
        Orders 
        <span class="text-base font-normal text-gray-500">
          ({{ orders().length }} {{ orders().length === 1 ? 'order' : 'orders' }})
        </span>
      </h2>

      <!-- Dropdown Menu Button -->
      <div class="relative dropdown-container">
        <button
          (click)="toggleDropdown(); $event.stopPropagation()"
          class="p-2 hover:bg-gray-200 rounded-lg transition-colors"
          aria-label="Menu"
        >
          <app-icon name="hamburger" class="w-6 h-6 text-gray-700" />
        </button>

        <!-- Dropdown Menu -->
        @if (isDropdownOpen()) {
          <div class="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-20 overflow-hidden">
            <button
              (click)="openReminderDialog()"
              class="w-full text-left px-4 py-3 hover:bg-gray-100 transition-colors"
            >
              Remind users (Done orders)
            </button>
            @if (notificationsNotAllowed()) {
              <button
                (click)="openNotificationDialog()"
                class="w-full text-left px-4 py-3 hover:bg-gray-100 transition-colors"
              >
                Enable notifications
              </button>
            }
          </div>
        }
      </div>
    </div>

    <!-- buttons wrap by themselves; text inside never wraps -->
    <div class="flex flex-wrap gap-2 justify-center">
      @for (f of filters(); track f.key) {
        @if (!f.operatorOnly || userId()) {
          <app-order-filter-button
            [label]="f.label"
            [count]="f.count"
            [active]="filter() === f.key"
            [color]="f.key"
            [hasUnseen]="f.hasUnseen"
            (select)="filter.set(f.key)"
          />
        }
      }
    </div>
  </div>

  <div class="flex-1 overflow-auto">
    @if (filteredOrders().length) {
      @for (order of filteredOrders(); track order.id) {
        <app-order-item [order]="order"></app-order-item>
      }
    } @else {
      <div class="p-4 text-center text-gray-500">No orders found for this filter.</div>
    }
  </div>
</div>

<!-- Reminder Dialog -->
@if (showReminderDialog()) {
  <app-done-order-reminder
    [doneOrders]="doneOrders()"
    (cancel)="closeReminderDialog()"
    (send)="sendReminder()"
  />
}

<!-- Notification Dialog -->
@if (showNotificationDialog()) {
  <app-notification-dialog
    (dismiss)="closeNotificationDialog()"
    (enable)="enableNotifications()"
  />
}